export const SET_DEALER_LOCALE = 'SET_DEALER_LOCALE';



// WEBPACK FOOTER //
// ./src/store/reducers/dealerLocale/actionTypes.js